<template>
  <div class="navigation-bar">  
    <div class="containerX">
      <!-- toolbar icon that direct to home page -->
      <!-- hhhhh lol -->
        <!-- <router-link to="/home" tag="span" style="cursor: pointer">
          <a
            title="Logo"
            @click="$router.push('/newprofile/projects')"
            class="logo"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="262.46"
              height="64.263"
              viewBox="0 0 262.46 64.263"
            >
              <g
                id="Group_77"
                data-name="Group 77"
                transform="translate(-461.499 -572.89)"
              >
                <g id="Group_76" data-name="Group 76">
                  <g id="Group_74" data-name="Group 74">
                    <path
                      id="Path_142"
                      data-name="Path 142"
                      d="M698.585,613.555a23.353,23.353,0,1,1-11.546-20.549,1.208,1.208,0,0,1,.669,1.71c-1.313,4.286.784,9.912,6.691,10.4a6.535,6.535,0,0,0,.777.041c2.055-.082,2.035-.079,2.595,1.982A24.6,24.6,0,0,1,698.585,613.555Zm-13.809-.176a9.959,9.959,0,0,0-9.889-10.217c-5.7.1-9.769,4.518-9.733,10.463a9.979,9.979,0,0,0,9.886,10.082C680.535,623.681,684.8,619.152,684.776,613.379Z"
                      fill="#fff"
                    />
                  </g>
                  <path
                    id="Path_143"
                    data-name="Path 143"
                    d="M652.987,628.518a26.478,26.478,0,0,1-.081-30.012c.6-.884.451-1.351-.248-2.014a22.866,22.866,0,0,0-16.6-6.642,24.369,24.369,0,0,0-3.039.229,22.651,22.651,0,0,0-12.07,5.241,32.325,32.325,0,0,1,3.3,14.5c0,7.5-2.356,14.235-6.1,18.893a23.155,23.155,0,0,0,16.44,8.328,23.547,23.547,0,0,0,18.267-6.83C653.466,629.61,653.486,629.244,652.987,628.518Zm-16.849-4.8a10.294,10.294,0,1,1,9.8-10.3A10.093,10.093,0,0,1,636.138,623.717Z"
                    fill="#fff"
                  />
                  <g id="Group_75" data-name="Group 75">
                    <path
                      id="Path_144"
                      data-name="Path 144"
                      d="M470.215,587.992h12.327l-8.716,47.072H461.5Z"
                      fill="#fff"
                    />
                    <path
                      id="Path_145"
                      data-name="Path 145"
                      d="M526.557,620.135c0,10.222-8.777,14.929-19.983,14.929H482.605l8.716-47.072h22.038c9.837,0,15.129,3.967,15.129,11.028,0,5.649-3.051,9.617-7.783,11.768A9.745,9.745,0,0,1,526.557,620.135Zm-12.264-.268c0-2.825-2.117-3.968-5.105-3.968H498.293l-1.743,9.549h10.708C511.554,625.448,514.293,623.632,514.293,619.867Zm-12.576-22.259-1.681,9.078h8.841c4.358,0,6.723-1.882,6.723-5.38,0-2.555-1.93-3.7-5.167-3.7Z"
                      fill="#fff"
                    />
                    <path
                      id="Path_146"
                      data-name="Path 146"
                      d="M549.408,598.281l-1.432,7.935h19.362l-1.8,9.952H546.109l-1.557,8.607H567.4l-1.992,10.289H530.482l8.716-47.072h34.116l-1.93,10.289Z"
                      fill="#fff"
                    />
                    <path
                      id="Path_147"
                      data-name="Path 147"
                      d="M606,610.519H616.9l-3.674,19.838a27.265,27.265,0,0,1-17.182,5.648c-13.323,0-21.914-8.406-21.914-20.711,0-16.341,11.144-28.243,27.7-28.243,8.716,0,15.067,3.025,18.989,8.674l-8.841,7.532c-2.863-3.833-6.225-5.178-10.708-5.178-8.965,0-14.692,6.926-14.692,16.34,0,6.322,3.984,10.558,11.144,10.558a14.386,14.386,0,0,0,5.79-1.143Z"
                      fill="#fff"
                    />
                  </g>
                  <path
                    id="Path_148"
                    data-name="Path 148"
                    d="M471.147,578.817a5.965,5.965,0,0,1,5.906-5.927,6.063,6.063,0,0,1,5.985,5.889,5.991,5.991,0,0,1-5.846,5.994A5.871,5.871,0,0,1,471.147,578.817Z"
                    fill="#5cc3b9"
                  />
                </g>
                <path
                  id="Path_149"
                  data-name="Path 149"
                  d="M683.512,576.6a15.071,15.071,0,0,1,6.538,3.759A15.94,15.94,0,0,1,695.3,592.7a14.224,14.224,0,0,0,.844,5.918,10.229,10.229,0,0,0,10.272,6.2c4.621-.478,6.151-1.121,10.422-4.17-.547,1.453-.982,2.961-1.661,4.349a16.682,16.682,0,0,1-31.715-7.3c-.028-6.745-.021-13.49-.022-20.235C683.444,577.215,683.483,576.962,683.512,576.6Z"
                  fill="#101c2b"
                />
                <path
                  id="Path_150"
                  data-name="Path 150"
                  d="M685.372,578.7a13.388,13.388,0,0,1,5.807,3.339,14.154,14.154,0,0,1,4.666,10.967,12.64,12.64,0,0,0,.75,5.256,9.082,9.082,0,0,0,9.123,5.5c4.1-.424,5.463-.995,9.256-3.7-.486,1.291-.872,2.63-1.475,3.863a14.817,14.817,0,0,1-28.168-6.479c-.025-5.991-.018-11.981-.019-17.972C685.312,579.248,685.346,579.023,685.372,578.7Z"
                  fill="#5cc3b9"
                />
                <path
                  id="Path_151"
                  data-name="Path 151"
                  d="M700.309,598.664c-.646-5.61.554-10.683,4.3-15.02a18.548,18.548,0,0,1,14.391-6.626c1.423-.019,2.846-.042,4.268-.011.242.005.691.285.686.424a29.378,29.378,0,0,1-.377,5.6c-.62,2.638-3.386,4.426-6.091,4.556-7.6.366-13.242,3.865-16.786,10.649a4.709,4.709,0,0,1-.257.411C700.437,598.663,700.391,598.655,700.309,598.664Z"
                  fill="#5cc3b9"
                />
              </g>
            </svg>
          </a>
        </router-link> -->
        
        <router-link class="logo" title="Logo" :to="{name: 'homePageX'}" >
          <svg width="124" height="22" viewBox="0 0 91 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M81.6095 13.8951C81.5945 17.7271 79.0175 20.9221 75.2695 21.7561C70.9235 22.7231 66.4905 19.8771 65.6405 15.4831C64.7125 10.6871 67.8105 6.95809 71.6115 6.05609C73.7375 5.55109 75.7625 5.77409 77.6705 6.88509C77.9225 7.03209 77.9945 7.15609 77.8985 7.46809C77.4505 8.93009 78.1665 10.8491 80.1815 11.0141C80.2695 11.0211 80.3585 11.0321 80.4465 11.0281C81.1475 11.0001 81.1405 11.0011 81.3315 11.7041C81.5265 12.4231 81.6075 13.1531 81.6095 13.8951ZM76.8985 13.8351C76.8895 11.8811 75.3895 10.3171 73.5245 10.3501C71.5815 10.3851 70.1925 11.8911 70.2045 13.9191C70.2165 15.8291 71.7195 17.3671 73.5775 17.3581C75.4515 17.3491 76.9075 15.8041 76.8985 13.8351Z" fill="white"/>
<path d="M66.0545 18.9991C63.9255 15.9021 63.9135 11.8551 66.0265 8.76112C66.2325 8.45912 66.1805 8.30011 65.9415 8.07411C64.3835 6.59511 62.5565 5.79212 60.2795 5.80812C60.0065 5.80012 59.6255 5.84212 59.2425 5.88612C57.6685 6.06612 56.2605 6.71612 55.1245 7.67412C55.8335 9.07812 56.2495 10.7821 56.2495 12.6211C56.2495 15.1781 55.4455 17.4771 54.1675 19.0661C55.5365 20.6611 57.5255 21.8161 59.7755 21.9071C62.1955 22.0051 64.2715 21.2761 66.0065 19.5771C66.2175 19.3721 66.2245 19.2471 66.0545 18.9991ZM60.3065 17.3621C58.4595 17.3731 56.9425 15.8001 56.9325 13.8641C56.9235 11.9421 58.4395 10.3521 60.2875 10.3451C62.1445 10.3381 63.6475 11.9041 63.6495 13.8481C63.6525 15.8041 62.1805 17.3511 60.3065 17.3621Z" fill="white"/>
<path d="M3.70542 5.17505H7.91042L4.93742 21.233H0.732422L3.70542 5.17505Z" fill="white"/>
<path d="M22.9256 16.14C22.9256 19.627 19.9316 21.233 16.1086 21.233H7.93262L10.9056 5.17505H18.4236C21.7786 5.17505 23.5846 6.52805 23.5846 8.93705C23.5846 10.864 22.5436 12.217 20.9296 12.951C22.2036 13.547 22.9256 14.649 22.9256 16.14ZM18.7416 16.048C18.7416 15.084 18.0196 14.694 16.9996 14.694H13.2836L12.6886 17.951H16.3416C17.8076 17.952 18.7416 17.332 18.7416 16.048ZM14.4516 8.45505L13.8786 11.552H16.8946C18.3816 11.552 19.1886 10.91 19.1886 9.71705C19.1886 8.84505 18.5306 8.45505 17.4256 8.45505H14.4516Z" fill="white"/>
<path d="M30.7206 8.68407L30.2316 11.3911H36.8366L36.2206 14.7861H29.5947L29.0636 17.7221H36.8576L36.1776 21.2321H24.2646L27.2376 5.17407H38.8756L38.2176 8.68407H30.7206Z" fill="white"/>
<path d="M50.0263 12.859H53.7433L52.4903 19.626C50.9613 20.865 48.8803 21.553 46.6293 21.553C42.0843 21.553 39.1533 18.686 39.1533 14.488C39.1533 8.91403 42.9553 4.85303 48.6043 4.85303C51.5773 4.85303 53.7443 5.88503 55.0813 7.81203L52.0653 10.381C51.0883 9.07303 49.9413 8.61503 48.4123 8.61503C45.3543 8.61503 43.4003 10.978 43.4003 14.189C43.4003 16.345 44.7593 17.791 47.2023 17.791C47.8823 17.791 48.5403 17.676 49.1773 17.401L50.0263 12.859Z" fill="white"/>
<path d="M4.02345 2.04508C4.01945 0.945079 4.93445 0.0270787 6.03845 0.0230787C7.13045 0.0200787 8.05645 0.931079 8.08045 2.03208C8.10345 3.11908 7.18245 4.06308 6.08645 4.07708C4.92445 4.09008 4.02845 3.20708 4.02345 2.04508Z" fill="#EEBA2E"/>
<path d="M76.4673 1.28809C77.3403 1.52709 78.0683 1.96809 78.6973 2.57009C79.8953 3.71509 80.5303 5.10709 80.4893 6.78209C80.4723 7.47109 80.5073 8.15109 80.7773 8.80109C81.3483 10.1761 82.8183 11.0671 84.2813 10.9151C85.8573 10.7521 86.3793 10.5321 87.8363 9.49209C87.6493 9.98809 87.5013 10.5021 87.2693 10.9761C86.2183 13.1241 83.7943 14.3811 81.3823 14.0581C79.0193 13.7411 76.9893 11.8561 76.5463 9.54709C76.4793 9.20009 76.4523 8.84109 76.4503 8.48709C76.4403 6.18609 76.4433 3.88509 76.4433 1.58409C76.4443 1.49809 76.4573 1.41209 76.4673 1.28809Z" fill="#101C2B"/>
<path d="M77.1012 2.00513C77.8762 2.21713 78.5232 2.60913 79.0822 3.14413C80.1462 4.16113 80.7102 5.39713 80.6742 6.88513C80.6592 7.49713 80.6902 8.10113 80.9302 8.67813C81.4372 9.89913 82.7432 10.6901 84.0422 10.5561C85.4422 10.4111 85.9052 10.2161 87.2002 9.29213C87.0342 9.73213 86.9022 10.1891 86.6972 10.6101C85.7642 12.5171 83.6112 13.6351 81.4692 13.3481C79.3702 13.0671 77.5672 11.3921 77.1742 9.34113C77.1152 9.03313 77.0902 8.71413 77.0892 8.40013C77.0812 6.35613 77.0832 4.31313 77.0832 2.26913C77.0812 2.19213 77.0922 2.11513 77.1012 2.00513Z" fill="#EEBA2E"/>
<path d="M82.1975 8.81506C81.9765 6.90106 82.3865 5.17106 83.6655 3.69106C84.9585 2.19706 86.6045 1.45806 88.5745 1.43106C89.0595 1.42406 89.5455 1.41606 90.0305 1.42706C90.1135 1.42906 90.2665 1.52406 90.2645 1.57206C90.2405 2.21106 90.2805 2.86906 90.1355 3.48206C89.9245 4.38206 88.9805 4.99206 88.0575 5.03606C85.4665 5.16106 83.5405 6.35506 82.3315 8.66906C82.3065 8.71806 82.2745 8.76306 82.2435 8.80906C82.2405 8.81506 82.2245 8.81206 82.1975 8.81506Z" fill="#EEBA2E"/>
          </svg>
        </router-link>

        <div class="content_mc_wrp">
          <div class="container-fluid" v-cloak>
            <div class="header__nav">
              <RouteMap v-if="crumbs.length > 0" :mapRoutes="crumbs" />
              <!-- <div v-if="navTabs" class="tabs_container">
                <NavTab
                  v-for="(tab, index) in navTabs"
                  :key="index"
                  v-bind="tab"
                  :active="tab.key == $route.name"
                />
              </div> -->
            </div>
          </div>
        </div>
    </div>
  </div>  
</template>

<script>
import NavTab from "../../components/global/NavTab.vue";
import RouteMap from "../../components/global/RouteMap.vue";
import { db } from "../../firebaseDB";
export default {
  
  data() {
    return {
      drawer: false,
      isList: false,
      appTtile: "iBegoo",
      selectedStoryTitle: '',
      selectedLogic: null,
      previousNode:'',
      nextNode:[],
      crumbs: [],
      tabs: {
        "user-info": [
          {
            text: "Email",
            color: "primary",
            link: "user-email",
            key: "user-email",
          },
          {
            text: "Security",
            color: "primary",
            link: "user-security",
            key: "user-security",
          },
        ],
        company: [
          {
            text: "Owner Info",
            color: "primary",
            link: "/profile",
            key: "profile",
          },
          {
            text: "Plans",
            color: "primary",
            link: "/newprofile/company/plans",
            key: "company-plans",
          },
          {
            text: "Billing",
            color: "primary",
            link: "/newprofile/company/billing",
            key: "company-billing",
          },
          {
            text: "Users",
            color: "primary",
            link: "/manage-users",
            key: "manageUsers",
          },
          {
            text: "Company Info",
            color: "primary",
            link: "/newprofile/company/company-info",
            key: "company-info",
          },
        ],
      },
    };
  },
  components: {
    RouteMap, NavTab
  },
  computed: {
    username() {
      let email = this.$store.state.user.email;
      // computed the user name format
      return "Welcome " + email.match(/([a-zA-Z0-9-_.]+)/gi)[0];
    },
    appTitle() {
      return this.$store.state.appTitle;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    navTabs(){
      if(['user-email','user-security'].includes(this.$route.name)) return this.tabs['user-info'];
      if(['profile','company-plans','company-billing','manageUsers','company-info'].includes(this.$route.name)) return this.tabs['company'];
      return null
    },
    // toolbarItems1 () {
    //   if (this.isAuthenticated) {
    //     return [
    //       // { title: 'Create Story', path: '/storylistCreate', icon: 'add' },
    //       { title: 'Story List', path: '/storylist', icon: 'book' },
    //       { title: 'Asset', path: '/assets', icon: 'build' }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // ExpansionItems () {
    //   if (this.isAuthenticated) {
    //     return [
    //       {
    //         drawer: true,
    //         action: 'build',
    //         title: 'Asset',
    //         active: true,
    //         items: [
    //           { title: 'Set Design', path: 'assets' },
    //           { title: 'Prop' },
    //           { title: 'Character Action' },
    //           { title: 'Character Model' },
    //           { title: 'Scene Name' },
    //           { title: 'Voice' },
    //           { title: 'Prop Action' },
    //           { title: 'Sound' }
    //         ]
    //       }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // toolbarItems2 () {
    //   if (this.isAuthenticated) {
    //     return [
    //       { title: 'Demo', path: '/welcome', icon: 'label' },
    //       { title: 'Edit Profile', path: '/editprofile', icon: 'person_outline' },
    //       { title: 'Contact', path: '/contact', icon: 'email' },
    //       { title: 'FAQ', path: '/faq', icon: 'help_outline' }
    //       // { title: 'Edit Profile', path: '/editprofile' },
    //       // { title: 'Stories', path: '/storylist' },
    //       // { title: 'Assets', path: '/assets' }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // menu contents list, please make sure you define the route in router's folder
    menuItems() {
      if (this.isAuthenticated) {
        return [
          { title: "Profile", path: "/profile", icon: "person_outline" },
          { title: "Stories", path: "/newprofile/projects", icon: "book" },
          { title: "Assets", path: "/assets", icon: "build" },
          { title: "API Calls", path: "/userclass", icon: "group" },
          // {title: 'Main Story', path: '/mainStoryView', icon: 'auto_stories'},
          // {title: 'Plans', path: '/plans', icon: 'grade'},
          // {title: 'New Profile', path: '/newprofile', icon: 'person_outline'},
          // { title: 'temp', path: '/temp', icon: 'face' }
          // { title: 'temp', path: '/temp', icon: 'face' },
          // {title: 'Manage Users', path: '/manage-users', icon: 'groups'}
        ];
      } else {
        return [
          { title: "Sign Up", path: "/signup", icon: "face" },
          { title: "Sign In", path: "/signin", icon: "lock_open" },
        ];
      }
    },
  },
  methods: {
    userSignOut() {
      this.$store.dispatch("userSignOut");
    },
  assignCrumbs(routername) {
      this.crumbs = [];
      this.getNodes()
       db.ref(`stories/` + localStorage.getItem("storyId") )
            .once('value')
            .then((snapshot) => {
      switch (routername) {
        //COMPANY
        case "profile":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "profile",
              name: "Profile",
            },
          ];
          break;
        case "company-plans":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "company-plans",
              name: "Plans",
            },
          ];
          break;
        case "company-billing":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "company-billing",
              name: "Billing",
            },
          ];
          break;
        case "manageUsers":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "manageUsers",
              name: "Owner Info",
            },
          ];
          break;
        case "company-info":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "Company",
            },
            {
              path: "company-info",
              name: "Company Info",
            },
          ];
          break;
        //USER INFO
        case "user-email":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "User Info",
            },
            {
              path: "user-email",
              name: "Email",
            },
          ];
          break;
        case "user-security":
          this.crumbs = [
            {
              path: "",
              name: "User Profile",
            },
            {
              path: "",
              name: "User Info",
            },
            {
              path: "user-security",
              name: "Security",
            },
          ];
          break;
        //PROJECTS
        case "add-story":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "add-story",
              name: "Add Story",
            },
          ];
          break;
        case "add-story-step-1":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "",
              name: "Add Story",
            },
            {
              path: "add-story-step-1",
              name: "Step 1",
            },
          ];
          break;
        case "add-story-step-2":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "",
              name: "Add Story",
            },
            {
              path: "add-story-step-1",
              name: "Step 1",
            },
            {
              path: "add-story-step-2",
              name: "Step 2",
            },
          ];
          break;
        // upload project
        case "update-story":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: "Dashboard",
              query: {
                title: this.selectedStoryTitle,
                id: localStorage.getItem("storyId"),
              },
            },
            {
              path: "settings",
              name: "settings",
            },
          ];
          break;
        case "update-story-step-1":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: "Dashboard",
              query: {
                title: this.selectedStoryTitle,
                id: localStorage.getItem("storyId"),
              },
            },
            {
              path: "",
              name: "settings",
            },
            {
              path: "update-story-step-1",
              name: "Step 1",
            },
          ];
          break;
        case "update-story-step-2":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: "Dashboard",
            },
            {
              path: "",
              name: "settings",
            },
            {
              path: "update-story-step-1",
              name: "Step 1",
            },
            {
              path: "update-story-step-2",
              name: "Step 2",
            },
          ];
          break;
        case "projects":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
          ];
          break;
        case "project-dashboard":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: `${this.selectedStoryTitle} Dashboard`,
              query: {
                title: this.selectedStoryTitle,
                id: localStorage.getItem("storyId"),
              },
            },
          ];
          break;
        case "comingsoon":
          this.crumbs = [
            {
              path: "",
              name: "Projects",
            },
            {
              path: "",
              name: "Coming Soon",
            },
          ];
          break;
        case "assets":
          this.crumbs = [
            {
              path: "assets",
              name: "Assets",
            },
          ];
          break;
        case "userclass":
          this.crumbs = [
            {
              path: "userclass",
              name: "API Calls",
            },
          ];
          break;
        case "abxr-market":
          this.crumbs = [
            {
              path: "abxr-market",
              name: "ABXR Market",
            },
          ];
          break;
        case "support":
          this.crumbs = [
            {
              path: "support",
              name: "Support",
            },
          ];
          break;
        case "legal":
          this.crumbs = [
            {
              path: "legal",
              name: "Legal",
            },
          ];
          break;
        case "updates":
          this.crumbs = [
            {
              path: "updates",
              name: "Updates",
            },
          ];
          break;
        case "mainStoryView":
        this.crumbs = [
          {
            path: "projects",
            name: "Projects Gallery",
          },
          {
            path: "project-dashboard",
            name: `${this.selectedStoryTitle} Dashboard`,
            query: {
                title: this.selectedStoryTitle,
                id: localStorage.getItem("storyId"),
              },
          },
          {
            path: "mainStoryView",
            name: `Decision Tree`,
          },
        ];
        break;
        case "storyEditView":
          let previous,next
          if(this.previousNode!=''){
           previous ={
            path: "",
            name: this.previousNode.name.replace(/([a-z])(\d)/gi, '$1 $2'),
            node: this.previousNode.nodeType.replace('Node', ""),
            realNode: this.previousNode,
            thereNext: true,
          }
          }else{
            previous = ''
          }
          if(this.nextNode.length>0){
            next ={
              path: "",
              name: this.nextNode[0].name.replace(/([a-z])(\d)/gi, '$1 $2'),
              node: this.nextNode[0].nodeType.replace('Node', ""),
              realNode: this.nextNode[0],
              next: true,
            }
          }else{
            next =''
          }
          this.crumbs = [
            {
              path: "projects",
              name: "Projects Gallery",
            },
            {
              path: "project-dashboard",
              name: `${this.selectedStoryTitle} Dashboard`,
              query: {
                title: this.selectedStoryTitle,
                id: localStorage.getItem("storyId"),
              },
            },
            {
              path: "mainStoryView",
              name: `Decision Tree`,
            },
            previous,
            {
              path: "",
              name: JSON.parse(localStorage.getItem('selectedLogic')).name.replace(/([a-z])(\d)/gi, '$1 $2'),
              node: JSON.parse(localStorage.getItem('selectedLogic')).category,
              realNode: JSON.parse(localStorage.getItem('selectedLogic')),
              main: true,
              thereNext: true,
            },
            next,
          ];
          if(this.previousNode == '') {
            this.crumbs.splice(3, 1);
          }
          if(this.nextNode.length == 0) {
            this.crumbs.splice(5, 1);
            this.crumbs[4].thereNext = false;
          }
        break;
        case "logicEditView":
          var next=[]
          let storyData = snapshot.val()
          let LogicExists = storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.key)
           if(this.nextNode.length>1 && LogicExists.length !== 0 && LogicExists[0]  &&  LogicExists[0].conditions){
             this.nextNode.forEach((element, index) => {
               next[index]={
                  path: "",
                  name: element.name.replace(/([a-z])(\d)/gi, '$1 $2'),
                  node: element.nodeType.replace('Node', ""),
                  realNode: element,
                  next: true,
              }
             });
          }else if(LogicExists !== 0  && LogicExists[0] && LogicExists[0].conditions){
           next = {
            path: "",
            name: this.nextNode[0].name.replace(/([a-z])(\d)/gi, '$1 $2'),
            node: this.nextNode[0].nodeType.replace('Node', ""),
            realNode: this.nextNode[0],
          }
          }
        this.crumbs = [
          {
            path: "projects",
            name: "Projects Gallery",
          },
          {
            path: "project-dashboard",
            name: `${this.selectedStoryTitle} Dashboard`,
            query: {
                title: this.selectedStoryTitle,
                id: localStorage.getItem("storyId"),
              },
          },
          {
            path: "mainStoryView",
            name: `Decision Tree`,
          },
          {
            path: "",
            name: this.previousNode.name.replace(/([a-z])(\d)/gi, '$1 $2'),
            node: this.previousNode.nodeType.replace('Node', ""),
            realNode: this.previousNode,
            thereNext: true,
          },
           {
            path: "",
            name: JSON.parse(localStorage.getItem('selectedLogic')).name.replace(/([a-z])(\d)/gi, '$1 $2'),
            node: JSON.parse(localStorage.getItem('selectedLogic')).category,
            realNode: JSON.parse(localStorage.getItem('selectedLogic')),
            main: true,
            thereNext: true,
          },next
        ];
        if(this.previousNode == '') {
          this.crumbs.splice(3, 1);
        }
        if(this.nextNode.length == 0) {
            this.crumbs.splice(5, 1);
            this.crumbs[4].thereNext = false;
        }
        break;
        case "simulation":
        this.crumbs = [
          {
            path: "projects",
            name: "Projects Gallery",
          },
          {
            path: "project-dashboard",
            name: `${this.selectedStoryTitle} Dashboard`,
            query: {
                title: this.selectedStoryTitle,
                id: localStorage.getItem("storyId"),
              },
          },
          {
            path: "mainStoryView",
            name: `Decision Tree`,
          },
          {
            path: "",
            name: `Simulation`,
          },
        ];
        break;
      }
            })
    
    },
    getNodes() {
      this.nextNode = []
      this.previousNode = ''
      let storyDta = {}
      this.selectedLogic = JSON.parse(localStorage.getItem("selectedLogic"));
      db.ref().child("stories/" + localStorage.getItem("storyId"))
      .on("value", (snapshot) => {
        storyDta = snapshot.val()
            if ( storyDta  &&  storyDta.json  &&  storyDta.json.storyName) {
              let json = storyDta.json;
              this.selectedStoryTitle = json.storyName;
              if(Object.keys(this.selectedLogic).length == 4){
                let previousNodeIndex = json.mainStory.nodes.findIndex((node) => node.name === storyDta.diagram.linkDataArray.filter( (node) => node.to === this.selectedLogic.name)[0].from);
                if(previousNodeIndex!=-1){this.previousNode = json.mainStory.nodes[previousNodeIndex]}
                  let nextNodeIndex
                if(storyDta.diagram.linkDataArray.filter( (node) => node.from === this.selectedLogic.name).length>0
                && json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name).length>0){
                  nextNodeIndex = json.mainStory.nodes.findIndex((node) => node.name === storyDta.diagram.linkDataArray.filter( (node) => node.from === this.selectedLogic.name)[0].to) ;
                if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].nodeType=='LogicNode'){
                  let this_ = this
                  if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions[0].conditionType=="STT" ){
                    json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.forEach(function (value, index) {
                    this_.nextNode.push(json.mainStory.nodes[value.stt.nextNodeID])
                    })
                  } else if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions[0].conditionType=="Probability" ){
                    json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.forEach(function (value, index) {
                    this_.nextNode.push(json.mainStory.nodes[value.probability.nextNodeID])
                    })
                  } else if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions[0].conditionType=='Touch'){
                  if( json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.length>0){
                    json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.forEach(function (value, index) {
                    this_.nextNode.push(json.mainStory.nodes[value.touch.nextNodeID])
                    })
                  } else {
                    this.nextNode.push(json.mainStory.nodes[nextNodeIndex])
                  }
                }
              } else if(json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].nodeType=='SceneNode' 
              && json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].nextNodeID!=-1){
                this.nextNode.push(json.mainStory.nodes[nextNodeIndex])
                }
              }
            }
          }
        })
    },
     goToNode(data){
       db.ref(`stories/` + localStorage.getItem("storyId") )
        .once('value')
        .then((snapshot) => {
      let storyData = snapshot.val()
     const nodeDataArray = storyData.diagram.nodeDataArray
      const nodePosition = nodeDataArray.findIndex((n) => n.key == data.key);
       const nodedata = nodeDataArray.filter((n) => n.key == data.name)[0];
      let selectedNode = {
        key: nodedata.key,
        name: nodedata.key,
        category: nodedata.category,
        nodePosition: nodePosition,
      };
      localStorage.setItem("selectedLogic", JSON.stringify(selectedNode));
      this.$store.dispatch("listUserStories");
      if (data && data.name.startsWith("Logic")) {
        this.$router.push("logicEditView");
      } else {
        if(this.$router.currentRoute.name!='storyEditView'){
        this.$router.push("storyEditView");
        }else{
         this.$router.go(this.$router.currentRoute)
        }
      }
        })
    },
    getStoryName() {
      let tRef = db.ref().child("stories/" + localStorage.getItem("storyId"));
      console.log(localStorage.getItem("storyId"))
      tRef.once('value')
        .then(snapshot => {
        let json = snapshot.val() && snapshot.val().json;
        if (json && json.storyName) {
          this.selectedStoryTitle = json.storyName;
          console.log(json.storyName);
        }
      });
    },
    getNodeX() {
    this.selectedLogic = this.$store.state.selectedLogic;
  }
  },
  watch: {
    $route(to, from) {
      this.assignCrumbs(to.name);
      this.getStoryName(to.name);
    },
  },
  mounted() {
    this.selectedLogic = this.$store.state.selectedLogic;
    this.assignCrumbs(this.$route.name);
  },
  beforeMount() {
    console.log(this.$store.state.selectedLogic);
    console.log(JSON.parse(localStorage.getItem('selectedLogic')).name);
  },
  
};
</script>

<style scoped lang="scss">
// .content_mc_wrp {
//   color: #000;
// }
.tabs_container {
  display: flex;
  align-items: end;
  width: 100%;
  height: 6rem;
  padding: 1rem 0;
}
.container {
  padding: 0 30px !important;
}
.header__nav {
  padding-bottom: 1rem;
}
.vv-logo {
  display: flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
  
  svg {
    position: relative;
    max-width: 120px;
    height: 24px;
    margin-right: 10px;
    bottom: 3px;
  }
}
.mainHeader {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 24px;
}
.containerX{
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 820px) {
  .vv-logo {
  svg {
    height: 24px;
    max-width: 100px;
  }
  }
  .navigation-bar {
  display: none;
}
}
// .vv-toolbar {
//   z-index: 25;
// }
</style>


// WEBPACK FOOTER //
// src/components/global/MainHeader.vue